var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAlertShowLess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button/show less/default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.296562412,5.70222799 C0.105898375,5.51078628 0.00716164178,5.28515855 0.000352211891,5.02534481 C-0.006457218,4.76553106 0.0854700855,4.53990334 0.276134122,4.34846163 L4.32093547,0.28716256 C4.41626749,0.191441707 4.52181366,0.119651067 4.63757396,0.0717906401 C4.75333427,0.0239302134 4.8724993,0 4.99506903,0 C5.11763877,0 5.23680379,0.0239302134 5.3525641,0.0717906401 C5.46832441,0.119651067 5.57387057,0.191441707 5.66920259,0.28716256 L9.71400394,4.32795002 C9.90466798,4.51939172 10,4.74843805 10,5.015089 C10,5.28173995 9.90466798,5.50394907 9.71400394,5.68171637 C9.52333991,5.87315808 9.29522401,5.96887893 9.02965624,5.96887893 C8.76408848,5.96887893 8.53597257,5.87315808 8.34530854,5.68171637 L4.99506903,2.33832371 L1.64482953,5.7227396 C1.46778435,5.9141813 1.24647788,6.00648356 0.980910116,5.99964635 C0.71534235,5.99280915 0.487226449,5.89366969 0.296562412,5.70222799 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button/show-less/default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/action/show-less",
    transform: "translate(7.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neutral-Fill",
    mask: "url(#mask-2)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.000000, -9.000000)",
    id: "Fill"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))), /*#__PURE__*/React.createElement("g", {
    id: "button-placer",
    fill: "#FFFFFF",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertShowLess);
export default __webpack_public_path__ + "static/media/icon_alert_show_less.21aba602d757b22c774671b026d65101.svg";
export { ForwardRef as ReactComponent };